if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      this.notifyButton = this.querySelector('[data-product-notify]');
      if (this.notifyButton) {
        this.notifyButton.addEventListener('click', this.onNotifyButtonClick.bind(this));
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append('id', this.querySelector('[name=id]').value);
        }

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        else {
          formData.append('sections', ['cart-icon-bubble', 'product-gifts']);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });

            if (!this.cart) {
              Toastify({
                text: `${window.cartStrings.addedToCart}`,
                duration: 1500,
                gravity: "top",
                position: "right",
                className: "toastify-success"
              }).showToast();

              if (response?.sections?.['cart-icon-bubble']) {
                const html = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
                const cartIconBubble = document.getElementById('cart-icon-bubble');
                if (cartIconBubble) {
                  cartIconBubble.innerHTML = html.getElementById('shopify-section-cart-icon-bubble').innerHTML;
                }
              }

              if (response?.sections?.['product-gifts']) {
                const html = new DOMParser().parseFromString(response.sections['product-gifts'], 'text/html');
                const productGifts = document.querySelector('.product__gifts-grid-hld');
                if (productGifts) {
                  const currentGrid = productGifts.querySelector('[data-product-gifts]');
                  const currentProgressWidth = currentGrid ? currentGrid.style.getPropertyValue('--progress-width-px') : '0px';

                  productGifts.innerHTML = html.getElementById('shopify-section-product-gifts').innerHTML;

                  const newGrid = productGifts.querySelector('[data-product-gifts]');
                  if (newGrid && currentProgressWidth && currentProgressWidth !== '0px') {
                    newGrid.style.setProperty('--progress-width-px', currentProgressWidth);
                  }

                  // Progress bar will be updated automatically by gift manager
                }
              }

              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
    }

    onNotifyButtonClick(evt) {
      evt.preventDefault();
      const appBtn = this.querySelector('.wc_wl_bis_btn button');
      if (appBtn) {
        appBtn.click();
      }
      return true;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
